import {
    Clear,
    Create,
    Done,
    Timer,
    Error,
    HelpOutline,
} from '@mui/icons-material';
import { Chip, SvgIconProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { chipColors } from '../../lib/contrast';

/**
 * El icono se guarda como componente, no como elemento ya construido: el color
 * del rótulo y el del icono salen del fondo (ver `chipColors`), así que no se
 * pueden fijar en la tabla. Antes iban los dos en blanco y sobre estos fondos
 * eso daba entre 1,6:1 (el `#ccc` por defecto) y 3,1:1.
 */
const theme: Record<
    string,
    { color: string; Icon: React.ComponentType<SvgIconProps> }
> = {
    PAID: { color: '#75bb41', Icon: Done },
    NOT_PAID: { color: '#ff5353', Icon: Clear },
    REFUNDED: { color: '#b058d7', Icon: Clear },
    PAYING: { color: '#eaab1e', Icon: Timer },
    CREATING: { color: '#4287f5', Icon: Create },
    ERROR: { color: '#ff0000', Icon: Error },
};

const defaultTheme = {
    color: '#cccccc',
    Icon: HelpOutline,
};

type SttChipPaymentStatusProps = {
    status: string | undefined;
};

/**
 * Chip payment status
 */
export function SttChipPaymentStatus({ status }: SttChipPaymentStatusProps) {
    const { t } = useTranslation();

    if (!status) {
        return null;
    }

    const selectedTheme = theme[status] ?? defaultTheme;
    const { backgroundColor, color } = chipColors(selectedTheme.color);
    const { Icon } = selectedTheme;

    return (
        <Chip
            icon={<Icon style={{ color }} />}
            size="small"
            label={t(`PS.${status}`)}
            style={{
                backgroundColor,
                color,
                border: '2px solid white',
            }}
        />
    );
}
